// English, householdsApp: same shape as householdsApp.nl.ts (golf 6b, household types and the
// chore rotation). English is complete (the type enforces it).
export const appHouseholdsEn = {
    question: 'Who lives in the home?',
    questionBody: 'Then we set up what suits you. You can change everything later, and nothing ever gets lost.',
    types: {
        family: {
            name: 'Family with children',
            body: 'Parents with children. Calendar, chores with stars, drop-offs and pick-ups.',
        },
        two_home: {
            name: 'Family with two homes',
            body: 'The children also live partly with the other parent. Calm and neutral.',
        },
        couple: {
            name: 'Couple',
            body: 'Two adults. A shared calendar, shopping and what needs doing.',
        },
        solo: {
            name: 'On my own',
            body: 'Keep on top of work, sport and appointments. Short and clear.',
        },
        student: {
            name: 'Student house',
            body: 'A fair cleaning rota, shopping and a message board. The board in the hallway knows whose turn the dishes are.',
        },
        shared: {
            name: 'Housemates',
            body: 'A shared home with adults. A fair rota and a board in the hallway.',
        },
        cohousing: {
            name: 'Co-housing or courtyard',
            body: 'Own homes with a shared space. A calendar for the common room, messages and who cleans.',
        },
        senior: {
            name: 'Older people at home',
            body: 'Living independently. Large text, appointments, reminders (medicines too) and the weather.',
        },
        care: {
            name: 'Older people at home, family keeps an eye',
            body: 'Someone who lives alone, with family keeping an eye from a distance. Large text, few buttons.',
        },
    },
    short: {
        family: 'Family',
        two_home: 'Family with two homes',
        couple: 'Couple',
        solo: 'On my own',
        student: 'Student house',
        shared: 'Housemates',
        cohousing: 'Co-housing or courtyard',
        senior: 'Older people at home',
        care: 'Older people with family',
    },
    /** Vervolgvraag bij Ouderen thuis (live r1): ja = care (familie kijkt mee), nee = senior. */
    seniorFamilyQuestion: 'Does family keep an eye from a distance?',
    yes: 'Yes',
    no: 'No',
    laterNote: 'Several generations under one roof? Choose Family with children.',
    modulesOn: 'We switch these on for you',
    modulesOnHint: 'Does this look right? You can switch any part on or off later in Settings.',
    confirm: 'Looks good, next',
    settingsTitle: 'Household type',
    settingsBody: 'Family, housemates, just me …',
    settingsIntro: 'The type decides which parts are on by default, how the app looks and a few words. Nothing is ever deleted.',
    current: 'Currently chosen',
    choose: 'Choose another type',
    previewTitle: 'What changes?',
    turnsOn: 'Switches on',
    turnsOff: 'Switches off',
    turnsOffNote: 'What is in it stays saved. Switch it back on later and everything is still there.',
    kept: 'Stays as you chose it',
    nothingChanges: 'The parts stay as they are. Only the look and a few words change.',
    lookChanges: 'The look adapts as well.',
    resetChoices: 'Also reset our own choices in Modules to the default',
    apply: 'Switch to {name}',
    cancel: 'Don’t switch',
    toast: 'Your household is now: {name}. Nothing was deleted.',
    onlyParents: 'Only an admin can change this.',
    words: {
        family: {
            members: 'Family members',
            profileTitle: 'What suits your family?',
            weatherBody: 'Coat, boots or sunscreen: we tell you at the moments the children head out.',
            adult: 'Parent',
            tasks: 'Tasks',
            cleaning: 'Cleaning',
            household: 'family',
            admin: 'Parent',
        },
        adults: {
            members: 'Who lives here',
            profileTitle: 'What suits you?',
            weatherBody: 'Coat, umbrella or sunscreen: we tell you just before you head out.',
            adult: 'Adult',
            tasks: 'Tasks',
            cleaning: 'Cleaning',
            household: 'household',
            admin: 'Admin',
        },
        shared: {
            members: 'Housemates',
            profileTitle: 'What suits your house?',
            weatherBody: 'Coat, umbrella or sunscreen: on the hallway board, just before you head out.',
            adult: 'Housemate',
            tasks: 'Tasks',
            cleaning: 'Cleaning',
            household: 'house',
            admin: 'Admin',
        },
        care: {
            members: 'Family',
            profileTitle: 'What suits you?',
            weatherBody: 'Coat, umbrella or sunscreen: we tell you just before you head out.',
            adult: 'Adult',
            tasks: 'Tasks',
            cleaning: 'Cleaning',
            household: 'household',
            admin: 'Carer',
        },
    },
    greetingHouse: 'Good to see you',
    wizardRotationTitle: 'A fair rota',
    wizardRotationBody: 'Kitchen, bathroom, hallway, bins and dishes rotate every week, and someone else cooks every evening. The hallway board shows whose turn it is.',
    wizardAdultsTitle: 'Ready to go',
    wizardAdultsBody: 'Put your appointments in the calendar and keep track of what needs doing. Your phone gives you a nudge when that helps.',
    wizardMembersShared: 'Who lives in the house? You can give everyone their own login later.',
    /** Golf 6b fixer r1: woorden bij "alleen" (enkelvoud; de rest van de volwassen set blijft). */
    soloWords: {
        members: 'Who belongs',
        profileTitle: 'What suits you?',
        profileBody: 'Choose cuisine, faith and food to mostly see what fits you. You don’t have to.',
    },
    /** Live r1: woorden bij een woongroep of hofje (bovenop de volwassen set). */
    cohousingWords: {
        members: 'Residents',
        profileTitle: 'What suits your community?',
        household: 'community',
        adult: 'Resident',
    },
    /** Golf 6b fixer r1: toon per soort (geen kindertaal bij volwassen soorten; gezin = standaard). */
    tone: {
        adults: {
            membersTitle: 'Who lives here',
            membersIntro: 'Everyone on the board. Each person’s colour shows up everywhere.',
            membersAdd: 'Person',
            membersAddLong: 'Add person',
            membersNew: 'New person',
            namePlaceholder: 'For example Noor',
            face: 'Icon',
            kidLockTitle: 'Tablet lock',
            kidLockBody: 'A PIN before someone ticks something off on the tablet. Off by default.',
            exportAll: 'Everyone',
            devicesIntro: 'The tablets your board runs on.',
            library: 'Task ideas',
            libraryIntro: 'Pick a task and who it is for.',
            wizardMembersTitle: 'Who lives here?',
            wizardMembersBody: 'Give everyone their own colour. You will see it everywhere.',
            noTasksTitle: 'No tasks today',
            noTasksBody: 'All caught up.',
            tasksWidget: 'Tasks today',
            tasksAll: 'All tasks',
            tasksEmptyBody: 'Start with something small, like the laundry or watering the plants.',
            exportBody: 'Download the calendar as an .ics file, for everyone or per person.',
            dataBody: 'A copy of your data as a file (JSON), including the choices in {profile}. You confirm with your password first.',
            dataAll: 'Everything',
            privacyEntryBody: 'Download everything, remove someone or delete the board.',
            approvalHint: 'Someone else checks the task before it counts as done.',
            supportIntro: 'Need help? AMUMIN can look along for a while, read only. You decide how long, and any admin can always stop it right away.',
            supportOff: 'Off. Nobody at AMUMIN can see your board.',
            supportSees: 'AMUMIN then sees: the names of everyone on the board, the titles of events for today and the next 6 days (a title can say something like Dentist; events with a faith icon such as mosque or church are left out), the rooms and the tablets. Not: faith, health, school, email addresses or photos. Every time AMUMIN looks along is listed below.',
        },
        solo: {
            membersTitle: 'Who belongs',
            membersIntro: 'You, and anyone you add later. Your colour shows up everywhere.',
            membersAdd: 'Person',
            membersAddLong: 'Add person',
            membersNew: 'New person',
            namePlaceholder: 'For example Noor',
            face: 'Icon',
            kidLockTitle: 'Tablet lock',
            kidLockBody: 'A PIN before someone ticks something off on the tablet. Off by default.',
            exportAll: 'Everything',
            devicesIntro: 'The tablets your board runs on.',
            library: 'Task ideas',
            libraryIntro: 'Pick a task you do regularly.',
            wizardMembersTitle: 'Anyone else?',
            wizardMembersBody: 'You are already on the board. Is there someone else, for shared appointments for example? Add them here or later.',
            noTasksTitle: 'No tasks today',
            noTasksBody: 'All caught up.',
            tasksWidget: 'Tasks today',
            tasksAll: 'All tasks',
            tasksEmptyBody: 'Start with something small, like the laundry or watering the plants.',
            exportBody: 'Download the calendar as an .ics file, for everyone or per person.',
            dataBody: 'A copy of your data as a file (JSON), including the choices in {profile}. You confirm with your password first.',
            dataAll: 'Everything',
            privacyEntryBody: 'Download everything, remove someone or delete the board.',
            approvalHint: 'You check the task yourself before it counts as done.',
            supportIntro: 'Need help? AMUMIN can look along for a while, read only. You decide how long, and you can always stop it right away.',
            supportOff: 'Off. Nobody at AMUMIN can see your board.',
            supportSees: 'AMUMIN then sees: the names of everyone on the board, the titles of events for today and the next 6 days (a title can say something like Dentist; events with a faith icon such as mosque or church are left out), the rooms and the tablets. Not: faith, health, school, email addresses or photos. Every time AMUMIN looks along is listed below.',
        },
        shared: {
            membersTitle: 'Housemates',
            membersIntro: 'Everyone who lives in the house. Each person’s colour shows up everywhere.',
            membersAdd: 'Housemate',
            membersAddLong: 'Add housemate',
            membersNew: 'New housemate',
            namePlaceholder: 'For example Sanne',
            face: 'Icon',
            kidLockTitle: 'Tablet lock',
            kidLockBody: 'A PIN before someone ticks something off on the hallway tablet. Off by default.',
            exportAll: 'Whole house',
            devicesIntro: 'The tablets the house board runs on.',
            library: 'Task ideas',
            libraryIntro: 'Pick a task and who does it.',
            wizardMembersTitle: 'Who lives here?',
            wizardMembersBody: 'Who lives in the house? You can give everyone their own login later.',
            noTasksTitle: 'No tasks today',
            noTasksBody: 'Check the rota to see who does what.',
            tasksWidget: 'Tasks today',
            tasksAll: 'All tasks',
            tasksEmptyBody: 'Start with something small, like putting the bins out.',
            exportBody: 'Download the calendar as an .ics file, for everyone or per person.',
            dataBody: 'A copy of your data as a file (JSON), including the choices in {profile}. You confirm with your password first.',
            dataAll: 'Whole house',
            privacyEntryBody: 'Download everything, remove someone or delete the board.',
            approvalHint: 'A housemate checks the task before it counts as done.',
            supportIntro: 'Need help? AMUMIN can look along for a while, read only. You decide how long, and any admin in the house can always stop it right away.',
            supportOff: 'Off. Nobody at AMUMIN can see your house board.',
            supportSees: 'AMUMIN then sees: the names of everyone on the board, the titles of events for today and the next 6 days (a title can say something like Dentist; events with a faith icon such as mosque or church are left out), the rooms and the tablets. Not: faith, health, school, email addresses or photos. Every time AMUMIN looks along is listed below.',
        },
        care: {
            membersTitle: 'Family',
            membersIntro: 'Everyone who helps out or is on the board. Each person’s colour shows up everywhere.',
            membersAdd: 'Person',
            membersAddLong: 'Add person',
            membersNew: 'New person',
            namePlaceholder: 'For example Anja',
            face: 'Icon',
            kidLockTitle: 'Tablet lock',
            kidLockBody: 'A PIN before someone ticks something off on the tablet. Off by default.',
            exportAll: 'Everyone',
            devicesIntro: 'The tablets the board runs on.',
            library: 'Task ideas',
            libraryIntro: 'Pick a task and who it is for.',
            wizardMembersTitle: 'Who helps out?',
            wizardMembersBody: 'Add everyone who helps out or should be on the board. Each person gets their own colour.',
            noTasksTitle: 'No tasks today',
            noTasksBody: 'All caught up.',
            tasksWidget: 'Tasks today',
            tasksAll: 'All tasks',
            tasksEmptyBody: 'Start with something small, like medication or shopping.',
            exportBody: 'Download the calendar as an .ics file, for everyone or per person.',
            dataBody: 'A copy of your data as a file (JSON), including the choices in {profile}. You confirm with your password first.',
            dataAll: 'Everything',
            privacyEntryBody: 'Download everything, remove someone or delete the board.',
            approvalHint: 'An admin checks the task before it counts as done.',
            supportIntro: 'Need help? AMUMIN can look along for a while, read only. You decide how long, and any admin can always stop it right away.',
            supportOff: 'Off. Nobody at AMUMIN can see your board.',
            supportSees: 'AMUMIN then sees: the names of everyone on the board, the titles of events for today and the next 6 days (a title can say something like Dentist; events with a faith icon such as mosque or church are left out), the rooms and the tablets. Not: faith, health, school, email addresses or photos. Every time AMUMIN looks along is listed below.',
        },
    },
    rotation: {
        title: 'Chore rota',
        intro: 'Chores rotate fairly: whoever had their turn goes to the back of the queue. Anyone who is away skips a turn and is first in line again afterwards.',
        thisWeek: 'This week',
        today: 'Today',
        nextUp: 'Next',
        weekOf: 'week of {date}',
        nobody: 'Nobody takes part',
        done: 'Done by {name}',
        notYet: 'Not done yet',
        swapped: 'Swapped',
        skipped: '{name} is away',
        swap: 'Swap',
        swapTitle: 'Who does {duty} {period}?',
        swapPeriodWeek: 'this week',
        swapPeriodDay: 'today',
        swapUndo: 'Undo swap',
        swapSaved: '{name} does {duty}',
        swapRemoved: 'The swap was undone',
        away: 'Away',
        awayTitle: 'Someone is away for a while',
        awayBody: 'On holiday or away for work? They skip a turn and are first in line again afterwards.',
        awayWho: 'Who',
        awayFrom: 'From',
        awayTo: 'Until and including',
        awayAdd: 'Mark as away',
        awayRemove: 'Back home',
        awayItem: '{name}: {from} until {to}',
        awaySaved: '{name} is marked as away',
        awayRemoved: '{name} is back home',
        awayInvalid: 'The end date is before the start date.',
        empty: 'No chore rota yet',
        emptyBody: 'Create a rota with kitchen, bathroom, hallway, bins, dishes and cooking. Afterwards you can remove or add chores in Cleaning.',
        setup: 'Create the chore rota',
        setupDone: '{count} chores are in the rota',
        setupNothing: 'These chores are already in the rota',
        weekly: 'Every week',
        daily: 'Every day',
        others: 'Other chores',
        othersBody: 'Chores from Cleaning that do not rotate yet.',
        makeWeekly: 'Rotate every week',
        makeDaily: 'Rotate every day',
        stopRotating: 'Stop rotating',
        rotatingOn: '{duty} now rotates',
        rotatingOff: '{duty} no longer rotates',
        onBoard: 'The hallway board shows whose turn it is this week. Tick it off there with a tap.',
        duties: {
            kitchen: 'Kitchen',
            bathroom: 'Bathroom',
            hallway: 'Hallway and stairs',
            trash: 'Bins',
            dishes: 'Dishes',
            cooking: 'Cooking',
        },
    },
};
//# sourceMappingURL=householdsApp.en.js.map